import { BJProfile } from 'types/bjProfile';

// webapp primeList.js·tabPrimeMatch.js 의 접속 상태 임계값·색상과 같은 값
const JUST_NOW_MS = 5 * 60 * 1000;
const A_FEW_MINUTES_MS = 30 * 60 * 1000;
const TODAY_MS = 24 * 60 * 60 * 1000;

export type PrimeState = { label: string; color: string };

export const getPrimeState = (bjProfile: BJProfile): PrimeState | null => {
  if (bjProfile.online) return { label: 'ONLINE', color: '#00E2FF' };

  const gap = BUtil.getCachedServerTime() - (bjProfile.lastPing ?? 0);
  if (gap < JUST_NOW_MS) return { label: 'Just now', color: '#00FFCE' };
  if (gap < A_FEW_MINUTES_MS) return { label: 'A few minutes ago', color: '#2AFD6E' };
  if (gap < TODAY_MS) return { label: 'Today', color: '#FFC950' };
  if (BERMUDA_CONFIG.PRIME_OFFLINE_DISPLAY) return { label: 'OFFLINE', color: '#FF5F5F' };
  return null;
};
